import * as React from "react";
import { trim } from "lodash";
import classnames from "classnames";
import { Box, Flex } from "@rebass/grid";
import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
  Intent,
  Text,
} from "@blueprintjs/core";

interface IProps {
  isOpen: boolean;
  isAddLoading: boolean;
  isValid(tagName: string): boolean;
  onSave(tagName: string): void;
  onCancel(): void;
}

interface IState {
  errorMsg: string;
  outputName: string;
}

const errorMsgClasses = classnames(Classes.TEXT_SMALL, Classes.INTENT_DANGER);

const customDialogCSS = {
  minWidth: "600px",
};

class AddOutputTagModal extends React.Component<IProps, IState> {
  public constructor(props: IProps) {
    super(props);

    this.state = {
      outputName: "",
      errorMsg: "",
    };
  }

  public render() {
    const { isOpen, isAddLoading } = this.props;
    const { errorMsg, outputName } = this.state;

    return (
      <Dialog
        isOpen={isOpen}
        title="New Output Tag"
        onClose={this.handleCancel}
        style={customDialogCSS}
      >
        <div className={Classes.DIALOG_BODY}>
          <FormGroup
            label="Output Tag Name"
            labelFor="output-name-input"
            labelInfo="(required)"
          >
            <InputGroup
              id="output-name-input"
              defaultValue={outputName}
              onChange={this.handleNameChange}
              placeholder="Output Tag Name"
              required={true}
            />
            {errorMsg && (
              <Box py={1}>
                <Text className={errorMsgClasses}>{errorMsg}</Text>
              </Box>
            )}
          </FormGroup>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <Flex justifyContent="space-between">
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                onClick={this.handleCancel}
                disabled={this.props.isAddLoading}
              >
                Cancel
              </Button>
              <Button
                intent={Intent.PRIMARY}
                onClick={this.handleSave}
                disabled={!outputName || isAddLoading}
                loading={isAddLoading}
              >
                Create Output Tag
              </Button>
            </div>
          </Flex>
        </div>
      </Dialog>
    );
  }

  private handleNameChange = (e: React.FormEvent<HTMLInputElement>): void =>
    this.setState({
      outputName: trim(e.currentTarget.value),
    });

  private handleCancel = (): void => this.props.onCancel();

  private handleSave = (): void => {
    const { isValid, onSave } = this.props;
    const { outputName } = this.state;

    if (isValid(outputName)) {
      onSave(outputName);
    } else {
      this.setState({
        errorMsg: "Please provide a unique Name",
      });
    }
  };
}

export default AddOutputTagModal;
